import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container has-table" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "log"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "action-list" }
const _hoisted_6 = { class: "color-danger" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "tips",
  style: {"margin-bottom":"10px","color":"#E6A23C"}
}
const _hoisted_9 = {
  key: 4,
  class: "tips"
}
const _hoisted_10 = { style: {"line-height":"2","text-align":"left"} }
const _hoisted_11 = {
  class: "dialog-footer",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.pageType==='卡券销售列表' || _ctx.pageType==='卡券销售记录' || _ctx.pageType==='卡券激活列表')
        ? (_openBlock(), _createBlock(_component_el_select_v2, {
            key: 0,
            class: "filter-item",
            filterable: "",
            modelValue: _ctx.filters.sale_channel_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.sale_channel_id) = $event)),
            clearable: "",
            options: _ctx.saleChannelList,
            props: _ctx.saleListProps,
            placeholder: "请选择销售渠道名称"
          }, null, 8, ["modelValue", "options", "props"]))
        : _createCommentVNode("", true),
      (_ctx.pageType==='卡券销售列表' || _ctx.pageType==='卡券销售记录')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: _ctx.filters.salesman_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.salesman_id) = $event)),
              filterable: "",
              placeholder: "请选择销售人员",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.start_actived_at,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.start_actived_at) = $event)),
              placeholder: "请选择卡激活开始时间",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.end_actived_at,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.end_actived_at) = $event)),
              placeholder: "请选择卡激活结束时间",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.start_created_at,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.start_created_at) = $event)),
              placeholder: "请选择卡生成开始时间",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.end_created_at,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.end_created_at) = $event)),
              placeholder: "请选择卡生成结束时间",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.pageType!=='卡券激活列表')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: _ctx.filters.coupon_id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.coupon_id) = $event)),
              modelModifiers: { trim: true },
              placeholder: "券包ID，多个以英文逗号分隔",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: _ctx.filters.ids,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.ids) = $event)),
              modelModifiers: { trim: true },
              placeholder: "券码ID，多个以英文逗号分隔",
              title: _ctx.filters.ids,
              clearable: ""
            }, null, 8, ["modelValue", "title"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: _ctx.filters.start_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.start_id) = $event)),
              modelModifiers: { trim: true },
              placeholder: "券码开始ID",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: _ctx.filters.end_id,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.end_id) = $event)),
              modelModifiers: { trim: true },
              placeholder: "券码结束ID",
              clearable: ""
            }, null, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.pageType==='卡券激活列表' || _ctx.pageType==='卡券销售列表' || _ctx.pageType==='卡券销售记录')
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 3,
            class: "filter-item",
            modelValue: _ctx.filters.batch,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.batch) = $event)),
            modelModifiers: { trim: true },
            placeholder: "批次号",
            clearable: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.pageType==='卡券激活列表')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: _ctx.filters.status,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.status) = $event)),
              placeholder: "卡券状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "待激活",
                  value: _ctx.CouponActiveStatus['待激活']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "已激活",
                  value: _ctx.CouponActiveStatus['已激活']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "驳回",
                  value: _ctx.CouponActiveStatus['驳回']
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.start_date,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.start_date) = $event)),
              placeholder: "请选择卡创建开始时间",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: _ctx.filters.end_date,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.end_date) = $event)),
              placeholder: "请选择卡创建结束时间",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"])
          ], 64))
        : (_ctx.pageType==='卡券作废列表')
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 5,
              class: "filter-item",
              modelValue: _ctx.filters.status,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters.status) = $event)),
              placeholder: "卡券状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "已激活",
                  value: _ctx.CouponStatus['已激活']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "已作废",
                  value: _ctx.CouponStatus['已作废']
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createBlock(_component_el_select, {
              key: 6,
              class: "filter-item",
              modelValue: _ctx.filters.status,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.status) = $event)),
              placeholder: "卡券状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "未激活",
                  value: _ctx.CouponStatus['未激活']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "待激活",
                  value: _ctx.CouponStatus['待激活']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "已激活",
                  value: _ctx.CouponStatus['已激活']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "已绑定",
                  value: _ctx.CouponStatus['已绑定']
                }, null, 8, ["value"]),
                _createVNode(_component_el_option, {
                  label: "已作废",
                  value: _ctx.CouponStatus['已作废']
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"])),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSearch()))
      }, {
        default: _withCtx(() => _cache[50] || (_cache[50] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (_ctx.pageType==='卡券列表')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 7,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onBatchEdit()))
          }, {
            default: _withCtx(() => _cache[51] || (_cache[51] = [
              _createTextVNode("批量修改")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.pageType==='卡券列表' || _ctx.pageType==='卡券销售列表' || _ctx.pageType==='卡券销售记录')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 8,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onExport()))
          }, {
            default: _withCtx(() => _cache[52] || (_cache[52] = [
              _createTextVNode("批量导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.pageType==='卡券作废列表')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 9,
            class: "filter-btn",
            type: "primary",
            onClick: _ctx.onBatchCancel
          }, {
            default: _withCtx(() => _cache[53] || (_cache[53] = [
              _createTextVNode("批量作废")
            ])),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.pageType==='卡券列表')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 10,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.beforeDialogOpen(1, '权限修改')))
          }, {
            default: _withCtx(() => _cache[54] || (_cache[54] = [
              _createTextVNode("权限修改")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.pageType === '卡券销售列表' && (_ctx.userGroups.includes('5') || _ctx.userGroups.includes('1')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.pageType==='卡券销售列表')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "filter-btn",
                type: "primary",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.openCardDialog()))
              }, {
                default: _withCtx(() => _cache[55] || (_cache[55] = [
                  _createTextVNode("关卡")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            style: {"margin-left":"20px"},
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.router.push('/coupon/close-card-list')))
          }, "关卡记录>>")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      ref: "couponList",
      stripe: "",
      border: "",
      onSelectionChange: _ctx.onSelectionChange,
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        (_ctx.pageType==='卡券作废列表')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              width: "55",
              "reserve-selection": "",
              selectable: _ctx.checkCancelable,
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.couponChecked(_ctx.scope.row)))
            }, null, 8, ["selectable"]))
          : _createCommentVNode("", true),
        (_ctx.pageType==='卡券激活列表')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "user_coupon_ids",
              label: "券码ID",
              width: "90"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  title: scope.row.user_coupon_ids,
                  class: "ellipsis"
                }, _toDisplayString(scope.row.user_coupon_ids), 9, _hoisted_4)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "id",
              label: "券码ID",
              width: "90"
            })),
        (_ctx.pageType==='卡券激活列表')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "batch",
              label: "批次"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "sale_channel",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "面值",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_discount",
          label: "结算折扣",
          width: "70"
        }),
        (_ctx.pageType!=='卡券作废列表')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createVNode(_component_el_table_column, { label: "卡券形式" }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.coupon_type_val), 1)
                ]),
                _: 1
              }),
              (_ctx.pageType!=='卡券激活列表')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: "卡券类型"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.charge_coupon_type_val), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.pageType=='卡券激活列表')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    label: "卡券数量",
                    prop: "coupon_count"
                  }))
                : _createCommentVNode("", true),
              (_ctx.pageType=='卡券激活列表')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 2,
                    label: "卡券号段",
                    prop: "coupon_interval"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, { label: "卡券属性" }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.coupon_attribute_val), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "company_name",
                label: "公司"
              }),
              _createVNode(_component_el_table_column, {
                prop: "salesman_name",
                label: "销售人员"
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "status_val",
          label: "卡券状态",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          label: "蛋糕余额有效期",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            (scope.row.valid_from!==null && scope.row.valid_from!=='0000-00-00')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(`${scope.row.valid_from} 至 ${scope.row.valid_to}`), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.pageType !== '卡券激活列表')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              label: "出卡有效期",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                (scope.row.bind_from!==null && scope.row.bind_from!=='0000-00-00')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(`${scope.row.bind_from} 至 ${scope.row.bind_to}`), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.pageType!=='卡券作废列表')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              prop: "remark",
              label: "驳回原因"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "msg_log",
          label: "操作类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: _ctx.pageType == '卡券激活列表' ? '创建时间' : '操作时间'
        }, null, 8, ["label"]),
        (_ctx.pageType==='卡券作废列表')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: "生成时间"
              }),
              _createVNode(_component_el_table_column, {
                prop: "remark",
                label: "作废信息"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.msg)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", null, "作废时间：" + _toDisplayString(scope.row.tovoid_at), 1),
                        _createElementVNode("div", null, "作废原因：" + _toDisplayString(scope.row.msg), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.pageType!=='卡券销售列表' && _ctx.pageType!=='卡券销售记录')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 8,
              label: "操作",
              fixed: "right",
              width: "115"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.pageType==='卡券列表')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "small",
                        disabled: _ctx.CouponStatus[scope.row.status]!=='未激活' && _ctx.CouponStatus[scope.row.status]!=='已作废',
                        onClick: ($event: any) => (_ctx.beforeDialogOpen(scope.row, '编辑'))
                      }, {
                        default: _withCtx(() => _cache[56] || (_cache[56] = [
                          _createTextVNode("编辑")
                        ])),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.pageType==='卡券激活列表')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          disabled: _ctx.CouponActiveStatus[scope.row.status]!=='待激活',
                          onClick: ($event: any) => (_ctx.beforeDialogOpen(scope.row, '激活'))
                        }, {
                          default: _withCtx(() => _cache[57] || (_cache[57] = [
                            _createTextVNode("激活")
                          ])),
                          _: 2
                        }, 1032, ["disabled", "onClick"]),
                        _createVNode(_component_el_button, {
                          type: "warning",
                          size: "small",
                          class: "mt8",
                          disabled: _ctx.CouponActiveStatus[scope.row.status]!=='待激活',
                          onClick: ($event: any) => (_ctx.beforeDialogOpen(scope.row, '驳回'))
                        }, {
                          default: _withCtx(() => _cache[58] || (_cache[58] = [
                            _createTextVNode("驳回")
                          ])),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.pageType==='卡券作废列表')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "danger",
                        size: "small",
                        disabled: _ctx.CouponStatus[scope.row.status]!=='已激活' || scope.row.owner_id > 0,
                        onClick: ($event: any) => (_ctx.beforeDialogOpen(scope.row, '作废'))
                      }, {
                        default: _withCtx(() => _cache[59] || (_cache[59] = [
                          _createTextVNode("作废")
                        ])),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.filters.page,
      total: _ctx.total,
      pageSize:  _ctx.filters.page_size,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["currentPage", "total", "pageSize", "onPageChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.actionType,
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "before-close": _ctx.beforeDialogClose,
      width: "900px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: _ctx.beforeDialogClose }, {
          default: _withCtx(() => _cache[71] || (_cache[71] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => _cache[72] || (_cache[72] = [
            _createTextVNode("保 存")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.actionType==='编辑' || _ctx.actionType==='激活' || _ctx.actionType==='批量修改' || _ctx.actionType==='权限修改')
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              class: "form",
              ref: "couponEditForm",
              model: _ctx.formData,
              rules: _ctx.rules,
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                (_ctx.actionType==='激活')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "券码ID",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_ctx.formData.user_coupon_ids)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: _ctx.formData.user_coupon_ids,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.user_coupon_ids) = $event)),
                              type: "textarea",
                              disabled: ""
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, "此批次共" + _toDisplayString((_ctx.formData.user_coupon_ids.split(',')).length) + "张卡券", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.actionType==='编辑' || _ctx.actionType==='激活' || _ctx.actionType==='批量修改')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_el_form_item, {
                        label: "客户名称",
                        prop: "company_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_autocomplete, {
                            modelValue: _ctx.formData.company_name,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.company_name) = $event)),
                            disabled: _ctx.actionType==='激活',
                            "fetch-suggestions": _ctx.onCompanySearch,
                            "value-key": "name",
                            clearable: "",
                            placeholder: "请输入客户名称"
                          }, null, 8, ["modelValue", "disabled", "fetch-suggestions"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "渠道名称",
                        prop: "sale_channel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_autocomplete, {
                            modelValue: _ctx.formData.sale_channel,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.sale_channel) = $event)),
                            disabled: _ctx.actionType==='激活',
                            "fetch-suggestions": _ctx.onSaleChannelSearch,
                            "value-key": "company_all",
                            clearable: "",
                            placeholder: "请输入渠道名称"
                          }, null, 8, ["modelValue", "disabled", "fetch-suggestions"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "申请人",
                        prop: "salesman_id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.salesman_id,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.salesman_id) = $event)),
                            filterable: "",
                            placeholder: "请选择申请人",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "实体类型",
                        prop: "coupon_type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.coupon_type,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.coupon_type) = $event)),
                            filterable: "",
                            placeholder: "请选择实体类型"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.store.state.user.userInfo.username !== 'caiwu1')
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 0,
                                    label: "实体卡",
                                    value: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.store.state.user.userInfo.username !== 'caiwu1')
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 1,
                                    label: "电子码",
                                    value: 2
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_option, {
                                label: "预付卡",
                                value: 3
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "卡券面值",
                        prop: "amount"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.amount,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.amount) = $event)),
                            placeholder: "请输入卡券面值",
                            onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.formData.amount=_ctx.formData.amount.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "卡券属性",
                        prop: "coupon_attribute",
                        required: _ctx.formData.coupon_type==1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.formData.coupon_attribute,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.coupon_attribute) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: 1 }, {
                                default: _withCtx(() => _cache[60] || (_cache[60] = [
                                  _createTextVNode("常规卡")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: 2 }, {
                                default: _withCtx(() => _cache[61] || (_cache[61] = [
                                  _createTextVNode("定制卡")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: 3 }, {
                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                  _createTextVNode("体验卡")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["required"]),
                      _createVNode(_component_el_form_item, {
                        label: "结算折扣",
                        prop: "coupon_discount"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.coupon_discount,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.coupon_discount) = $event)),
                            placeholder: "请输入结算折扣",
                            onInput: _cache[32] || (_cache[32] = ($event: any) => (_ctx.formData.coupon_discount=_ctx.formData.coupon_discount.replace(/^\D*(\d*(?:\.\d{0,3})?).*$/g, '$1')))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.actionType==='编辑' || _ctx.actionType==='批量修改')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "申请激活",
                            prop: "activation"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_group, {
                                modelValue: _ctx.formData.activation,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.activation) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio, { value: 1 }, {
                                    default: _withCtx(() => _cache[63] || (_cache[63] = [
                                      _createTextVNode("是")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_radio, { value: 0 }, {
                                    default: _withCtx(() => _cache[64] || (_cache[64] = [
                                      _createTextVNode("否")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.actionType==='编辑' || _ctx.actionType==='权限修改' || _ctx.actionType==='批量修改' || _ctx.actionType==='激活')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "卡券类型",
                      prop: "rule_title"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.powerName== false)
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 0,
                              disabled: _ctx.actionType==='激活',
                              modelValue: _ctx.formData.rule_title,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.rule_title) = $event)),
                              onChange: _ctx.onRuleTitleChange,
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.powerName = false)),
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择卡券购买权限"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponPowerList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue", "onChange"]))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode(_component_el_input, {
                          modelValue: _ctx.formData.rule_title,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.rule_title) = $event)),
                          modelModifiers: { trim: true },
                          placeholder: "请输入卡券名称",
                          clearable: "",
                          onBlur: _ctx.checkPowerName
                        }, null, 8, ["modelValue", "onBlur"]), [
                          [_vShow, _ctx.powerName]
                        ]),
                        (_ctx.powerName == false)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              style: {"margin-left":"10px"},
                              type: "success",
                              disabled: _ctx.actionType==='激活',
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.powerName = true))
                            }, {
                              default: _withCtx(() => _cache[65] || (_cache[65] = [
                                _createTextVNode("特殊配置")
                              ])),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.powerName == true)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 2,
                              style: {"margin-left":"10px"},
                              type: "info",
                              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.powerName = false))
                            }, {
                              default: _withCtx(() => _cache[66] || (_cache[66] = [
                                _createTextVNode("返回")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.actionType==='编辑' || _ctx.actionType==='权限修改' || _ctx.actionType==='批量修改'  || _ctx.actionType==='激活')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      label: "商城购买权限",
                      prop: "buy_rule"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_cascader, {
                          disabled: _ctx.powerName==false || _ctx.actionType==='激活',
                          placeholder: "请选择商城购买权限",
                          props: _ctx.props,
                          options: _ctx.options,
                          modelValue: _ctx.formData.buy_rule,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.buy_rule) = $event)),
                          "collapse-tags-tooltip": "",
                          clearable: "",
                          multiple: "",
                          filterable: ""
                        }, null, 8, ["disabled", "props", "options", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (![1, 2, 3, 4].includes(_ctx.formData.rule_title) && _ctx.formData.buy_rule?.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      (_ctx.formData.buy_rule?.flat().includes('m'))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "是否加电影服务费",
                            prop: "movie_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_group, {
                                modelValue: _ctx.formData.movie_type,
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData.movie_type) = $event)),
                                disabled: _ctx.pageType!=='卡券列表'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio, { value: 1 }, {
                                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                                      _createTextVNode("是")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_radio, { value: 2 }, {
                                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                                      _createTextVNode("否")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.actionType==='编辑' || _ctx.actionType==='权限修改' || _ctx.actionType==='批量修改'  || _ctx.actionType==='激活')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      label: "出卡有效期",
                      prop: "bind_term"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: _ctx.actionType==='激活',
                          modelValue: _ctx.formData.bind_term,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.bind_term) = $event)),
                          modelModifiers: { trim: true },
                          filterable: "",
                          placeholder: "请输入出卡有效期",
                          min: "1",
                          onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.ChangeBind()))
                        }, {
                          append: _withCtx(() => _cache[69] || (_cache[69] = [
                            _createTextVNode("月")
                          ])),
                          _: 1
                        }, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.actionType==='编辑' || _ctx.actionType==='权限修改' || _ctx.actionType==='批量修改'  || _ctx.actionType==='激活')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      label: "蛋糕余额有效期",
                      prop: "valid_term"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          disabled: _ctx.actionType==='激活',
                          modelValue: _ctx.formData.valid_term,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.valid_term) = $event)),
                          modelModifiers: { trim: true },
                          filterable: "",
                          placeholder: "请输入蛋糕余额有效期"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "永久",
                              value: 0
                            }),
                            _createVNode(_component_el_option, {
                              label: "非永久",
                              value: _ctx.formData.bind_term
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
        (_ctx.actionType==='驳回')
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              "label-width": "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "驳回原因",
                  required: "",
                  style: {"width":"450px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      rows: 5,
                      maxlength: "100",
                      "show-word-limit": "",
                      modelValue: _ctx.remark,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.remark) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.actionType==='作废')
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 2,
              "label-width": "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "作废原因",
                  required: "",
                  style: {"width":"450px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      rows: 5,
                      maxlength: "100",
                      "show-word-limit": "",
                      modelValue: _ctx.msg,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.msg) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.valid_term!=0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, "注：非永久选项期限根据出卡有效期传入（即和出卡有效期一致）"))
          : _createCommentVNode("", true),
        (_ctx.actionType==='编辑' || _ctx.actionType==='权限修改' || _ctx.actionType==='批量修改')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[70] || (_cache[70] = [
              _createElementVNode("div", null, "注：权限选择", -1),
              _createElementVNode("div", null, "1.只选一级则代表一级下的全部权限（无需勾选二级，日后如有新增二级分类则自动绑定权限）", -1),
              _createElementVNode("div", null, "2.若选择二级分类则权限固定，日后如有新增二级分类须手动修改", -1),
              _createElementVNode("div", null, "3.若二级分类全选，也不代表拥有一级下的全部权限即日后新增的二级分类须手动修改", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "关卡后，用户不可绑卡",
      modelValue: _ctx.noticeDialog,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.noticeDialog) = $event)),
      "before-close": _ctx.closeCardDialog,
      width: "300px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, { onClick: _ctx.closeCardDialog }, {
            default: _withCtx(() => _cache[73] || (_cache[73] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.switchCard()))
          }, {
            default: _withCtx(() => _cache[74] || (_cache[74] = [
              _createTextVNode("关卡")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, "关卡总数量：" + _toDisplayString(_ctx.cardData.quantity), 1),
          _createElementVNode("div", null, "未绑数量：" + _toDisplayString(_ctx.cardData.untied_card_count), 1),
          _createElementVNode("div", null, "未绑金额：" + _toDisplayString(_ctx.cardData.untied_card_amount) + " 元", 1),
          _createElementVNode("div", null, "已绑数量： " + _toDisplayString(_ctx.cardData.already_card_count), 1),
          _createElementVNode("div", null, "已绑清除金额： " + _toDisplayString(_ctx.cardData.already_card_amount) + " 元", 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}